import type { ReactNode } from 'react';
import React from 'react';
import { type MessageDescriptor, useIntl } from 'react-intl';

import BackIcon from './BackIcon.svg';
import { BackIconWrapper, BackWrapper } from './wrappers';

interface BackButtonProps {
  /** on back button click */
  goBack: () => void;
  /** label for the back button */
  message: MessageDescriptor;
}

/**
 * Back button component for the Take Control modal
 */
export function BackButton({ goBack, message }: BackButtonProps): ReactNode {
  const { formatMessage } = useIntl();
  return (
    <BackWrapper onClick={goBack}>
      <BackIconWrapper src={BackIcon} alt="" />
      <div style={{ margin: 0, fontWeight: 600 }}>{formatMessage(message)}</div>
    </BackWrapper>
  );
}
